import { Component, Input, ViewChild, ElementRef } from '@angular/core';
import { RmsModule } from '../../custom-modules/rms-module/rms.module';

@Component({
  selector: 'app-payment-receipt',
  templateUrl: './payment-receipt.component.html',
  styleUrls: ['./payment-receipt.component.scss'],
  imports: [RmsModule]
})
export class PaymentReceiptComponent {

  @Input() data: any;

  @ViewChild('reportContent', { static: false }) reportContent!: ElementRef;

  get Payment() {
    return this.data?.payment || {};
  }

  get CustomerName(): string {
    return this.data?.customerName || '';
  }

  get SettledOrConfirmedDate(): string | null {
    return this.Payment.ConfirmationSentDate ?? this.Payment.SettledDate;
  }
}
